export default __webpack_public_path__ + "static/media/avatar.35a8db04.png";